document.addEventListener("DOMContentLoaded", function () {
  const productGrid = document.getElementById("product-grid");
  const wrapper = document.getElementById("load-more-wrapper");
  const loadMoreBtn = document.getElementById("load-more-btn");
  const trigger = document.getElementById("load-more-trigger");

  if (!productGrid || !wrapper || !loadMoreBtn || !trigger) return;

  let isLoading = false;
  const totalPages = parseInt(wrapper.getAttribute("data-total-pages"), 10);

  function loadNextPage() {
    if (isLoading) return;
    isLoading = true;

    const currentPage = parseInt(wrapper.getAttribute("data-current-page"), 10);
    const nextPage = currentPage + 1;

    // Check if there are more pages to load
    if (nextPage > totalPages) {
      observer.disconnect();
      loadMoreBtn.remove();
      trigger.remove();
      isLoading = false;
      return;
    }

    loadMoreBtn.textContent = "Loading...";
    Spinner.show();

    fetch(`${window.location.pathname}?page=${nextPage}`)
      .then(res => res.text())
      .then(data => {
        const doc = new DOMParser().parseFromString(data, "text/html");
        const items = doc.querySelectorAll("#product-grid .grid__item");

        if (items.length) {
          items.forEach(item => productGrid.appendChild(item));
          wrapper.setAttribute("data-current-page", nextPage);

          // Check if we've reached the last page
          if (nextPage >= totalPages) {
            observer.disconnect();
            loadMoreBtn.remove();
            trigger.remove();
          } else {
            loadMoreBtn.textContent = "Load More";
          }
        } else {
          observer.disconnect();
          loadMoreBtn.remove();
          trigger.remove();
        }
      })
      .catch(err => {
        console.error("Load More error:", err);
        loadMoreBtn.textContent = "Load More";
      })
      .finally(() => {
        isLoading = false;
        Spinner.hide();
      });
  }

  loadMoreBtn.addEventListener("click", loadNextPage);

  const observer = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {
      loadNextPage();
    }
  }, {
    rootMargin: "200px",
  });

  observer.observe(trigger);
});